import $ from 'jquery';
import '../scss/validation.scss';
import gaTracker from './ga-tracker';
import getUrlParameter from './get-url-parameter';
import updateUrlParameter from './update-url-parameter';
import isPage from './is-page';
import carousel from 'owl.carousel';
import {vfNetWorkCheck} from '../../v3/src/11_functions/_qaProdEndpoints'
import React from 'react';
import ReactDOM from 'react-dom';
import DeviceCompatibilityCheck from "./device-compatibility-check";
// import DeviceAutoComplete from './device-auto-complete-fix';
/*class DeviceAutoComplete {
	render() {
		return <div></div>
	}
}*/

var $btnPriceReduce = $('.js-price-reduce'),
	$btnPriceAdd = $('.js-price-add'),
	$productQty = $('.js-product-qty');
const networkCheckURL = vfNetWorkCheck()
$btnPriceReduce.on('click', function(){
	var num = parseInt($productQty.val(), 10);

	if(num === 1) {
		return;
	}

	num -= 1;

	$productQty.val(num);
	$productQty.change();
});

$btnPriceAdd.on('click', function(){
	var num = parseInt($productQty.val(), 10);

	num += 1;

	$productQty.val(num);
	$productQty.change();
});

if(document.getElementById('js-product-images')) {
	(function() {
		var owl_intro = $('#js-product-images').owlCarousel({
			loop: true,
			margin: 10,
			nav: false,
			center: true,
			touchDrag: true,
			pullDrag: true,
			mouseDrag: true,
			responsive: {
					0: {
						items: 1,
						dots: true
					},
					960: {
						items: 1,
						dots: true
					}
				}
			});

	})();
}

var zipApi = networkCheckURL,
	deviceApi = 'https://compatibility-api.mintsim.com/v1/device?modelName=',
	$pageTitle = $('.js-valid-title'),
	$coverageEntry = $('.js-coverage-entry'),
	$coverageResults = $('.js-coverage-results'),
	$coverageReset = $('.js-coverage-reset'),
	$zipForm = $('.js-valid-zip-form'),
	$zipCodeField = $('.js-valid-zip-code'),
	$zipDisplay = $('.js-show-zip-code'),
	$resultUncertain = $('.js-results-uncertain'),
	$resultSolid = $('.js-results-solid'),
	$resultCovered = $('.js-results-covered'),
	zipHolder = '',
	$compatibilityEntry = $('.js-compatibility-entry'),
	$compatibilityResults = $('.js-compatibility-results'),
	$compatibilityReset = $('.js-compatibility-reset'),
	$meter4glte = $('.js-meter-4glte'),
	$meter4g = $('.js-meter-4g'),
	$meter3g = $('.js-meter-3g'),
	$meter2g = $('.js-meter-2g'),
	$meterNotComp = $('.js-meter-not-comp'),
	$deviceNotCompatible = $('.js-compat-false'),
	$device4glte = $('.js-compat-4glte'),
	$device4g = $('.js-compat-4g'),
	$device3g = $('.js-compat-3g'),
	$device2g = $('.js-compat-2g'),
	$deviceName = $('.js-results-device-name'),
	$deviceForm = $('.js-valid-device-form'),
	params = {
		coverage: window.localStorage.getItem('coverage'),
		compatibility: window.localStorage.getItem('compatibility'),
		zip: window.localStorage.getItem('zip'),
		device: window.localStorage.getItem('device')
	};

if (document.getElementById('js-device-dropdown')) {
	$.ajax({
		url: (data_source.length > 0) ? data_source : window.location.origin + '/api/mint-device-list-final.json',
		success: function (response) {
			ReactDOM.render(
				<DeviceCompatibilityCheck devices={response} />,
				document.getElementById('js-device-dropdown')
			);
		}
	});
}

$deviceForm.on('submit', function(event) {
	event.preventDefault();
	var deviceName = $('[name=deviceModelSelect]').val(),
		checkDevice = $.ajax({
			type: 'get',
			url: deviceApi + encodeURI(deviceName)
		});
		
	checkDevice
		.done(function(response) {
			return handleDeviceSuccess(response, deviceName)
		})
});

$compatibilityReset.on('click', function(e) {
	e.preventDefault();
	setCompatibilityState('reset');
});

function setCompatibilityState(state) {
		
	if (state === 'reset') {
		window.localStorage.removeItem('compatibility');
		window.localStorage.removeItem('device');

		$("img[class^='js-meter-']").hide();
		$("div[class^='js-compat-']").hide();

		$compatibilityEntry.show();
		$compatibilityResults.hide();

		return;
	}

	var compatibility = state.compatibility,
		device = state.device;

	if (compatibility && (compatibility == '4GLTE' || compatibility == '4G' || compatibility == '3G' || compatibility == '2G')) {

		$deviceName.html(params.device);
		
		switch(compatibility) {
			case '4GLTE':
				$device4glte
					.add($meter4glte)
					.show();
				break;
			case '4G':
				$device4g
					.add($meter4g)
					.show();
				break;
			case '3G':
				$device3g
					.add($meter3g)
					.show();
				break;
			case '2G':
				$device2g
					.add($meter2g)
					.show();
				break;
			default: break;
		}
		
	} else {
		$deviceNotCompatible.add($meterNotComp).show();
	}

	$compatibilityEntry.hide();
	$compatibilityResults.show();
}

function handleDeviceSuccess(response, deviceName) {

	if (response[0] == null) {
		return;
	}
	
	var speedList = [],
		speeds = response.map(function(obj) {
			if (obj.compatibility['2G'] && speedList.indexOf('2G') === -1) { speedList.push('2G'); }
			if (obj.compatibility['3G'] && speedList.indexOf('3G') === -1) { speedList.push('3G'); }
			if (obj.compatibility['4G'] && speedList.indexOf('4G') === -1) { speedList.push('4G'); }
			if (obj.compatibility['LTE'] && speedList.indexOf('4GLTE') === -1) { speedList.push('4GLTE'); }
			if (speedList.length == 0 && speedList.indexOf('not-compatible') === -1) { speedList.push('not-compatible'); }
		}),
		compatibility = speedList.pop();

	params.compatibility = compatibility;
	params.device = $('[name=js-device-name]').val();

	gaTracker.track('deviceCheck|Check Device|' + window.location.pathname + '|' + deviceName + '|' + params.compatibility);

	storeValues(params);
	setCompatibilityState(params);

}

// Check zip coverage on form submit
$zipForm.on('submit', function(event) {
	event.preventDefault();
	var pageTitle = $pageTitle.text(),
		zipCode = $zipCodeField.val(),
		/** coverageUrl = zipApi + zipCode + '.json', Using the .json method **/
		coverageUrl = zipApi;
		let data = {
			address: {
			  zip: zipCode
			}
		};
		checkZipCode = $.ajax({
			type: 'post',
			url: coverageUrl,
			data: data,
			dataType: 'json'
		});
	if (!zipCode) {
		return false;
	}

	zipHolder = zipCode;
	
	checkZipCode
		.done(function(response) {
			return handleZipSuccess(response, zipCode)
		})
});

$coverageReset.on('click', function(e) {
	e.preventDefault();
	setCoverageState('reset');
});

function storeValues(data) {
	for (var key in data) {
		if (data.hasOwnProperty(key) && data[key]) {
			window.localStorage.setItem(key, data[key]);
		}
	}
}

function setCoverageState(state) {
	
	if (state === 'reset') {
		window.localStorage.removeItem('coverage');
		window.localStorage.removeItem('zip');

		$coverageEntry.show();
		$coverageResults.hide();

		return;
	}

	var coverage = parseInt(state.coverage, 10),
		zip = state.zip;

	if (coverage < 3) {
		$resultUncertain.show();
		$resultSolid.hide();
		$resultCovered.hide();
	} else {
		$resultUncertain.hide();
		
		if (coverage >= 3 && coverage <= 6) {
			$resultSolid.show();
		} else {
			$resultCovered.show();
		}
	}

	$coverageEntry.hide();
	$coverageResults.show();

	if (zip) {
		$zipDisplay.html(zip);
	}
}

function handleZipSuccess(response, zipCode) {
	params.coverage = response.quality;
	params.zip = zipHolder;
	gaTracker.track('zipCheck|Check Coverage|' + window.location.pathname + '|' + zipCode + '|' + response.quality);

	storeValues(params);
	setCoverageState(params);
}